import CommonModal from "../../ResetContext/components/DumpModal";
import { AlertTriangle, Check } from "lucide-react";
import { Button } from "components/ui/button";

const texts = [
  {
    icon: <Check className="text-emerald-600 mt-2" />,
    text: "Your existing work will remain saved in your account",
  },
  {
    icon: <AlertTriangle className="text-amber-500 mt-2" />,
    text: "You'll lose access to all premium features.",
  },
  {
    icon: <AlertTriangle className="text-amber-500 mt-2" />,
    text: "Team members will no longer have access.",
  },
];

const CancelModal = ({ isOpen, onClose, setOpenConfirmModal }) => {
  return (
    <CommonModal title="" showAlert={false} onClose={onClose} isOpen={isOpen}>
      <h4 className="text-xl font-semibold text-center mb-2">
        Cancel Your Plan
      </h4>
      <p className="px-4 text-center text-muted-foreground mb-4">
        You're about to cancel your plan. This action is permanent and cannot be
        undone.
      </p>
      {texts.map((item, index) => (
        <div className="mx-4 flex gap-4 py-5 border-b items-center" key={index}>
          {item.icon}
          <p key={index} className="mt-2 text-lg font-medium">
            {item.text}
          </p>
        </div>
      ))}
      <div className="mt-8 flex flex-col ">
        <Button
          variant="destructive"
          onClick={() => {
            setOpenConfirmModal(true);
            onClose();
          }}
        >
          Cancel plan
        </Button>
        <Button variant="outline" className="mt-3" onClick={onClose}>
          Keep my existing plan
        </Button>
      </div>
    </CommonModal>
  );
};

export default CancelModal;
